const cdnbasepath = `https://${process.env.REACT_APP_CDNBASEPATH}`;

const REWARD_LABELS = {
    productName: "Shop:",
    billingDate: "Billing Date:",
    billAmount: "Bill Amount:",
    amountSaved: "You Saved:",
    loyaltyEarned: "You Earned:",
    loyaltyBurnt: "You Burnt:",
    history: "History",
    balance: "Balance",
    rupee: 'Rs.',
    plus: '+',
    minus: '-'
};

const TAB_NAMES = {
    TAB1: "Physical Store",
    TAB2: "Online Store"
};

const MYREWARDS_MESSAGES = {
    TITLE: "My Rewards",
    NOREWARDS: "You have not got any rewards yet!",
    ERROR_MSG: "Error while fetching your rewards!",
    HOW_TO_USE: " How to use Rewards?",
    FIND_STORE: "Find the nearest Store >",
    STORELOCATOR: "/store-locator",
    LISTING: "/products",
    NOREWARDSMSG1: "There isn’t any trasaction here!",
    NOREWARDSMSG2: "It’s time that you need to burn your reward points.",
    NOREWARD_BTN_TEXT: "START SHOPPING"
};

const ENDPOINTS = {
    PHYSICAL_STORE_MODAL_IMG: `${cdnbasepath}/client/assets/images/icon/defaultSkuImage.png`,
    PHYSICAL_STORE_FIND_BUY_IMG: `${cdnbasepath}/client/assets/images/icon/defaultSkuImage.png`,
    PHYSICAL_STORE_APPLY_IMG: `${cdnbasepath}/client/assets/images/icon/defaultSkuImage.png`,
    PHYSICAL_STORE_DISCOUNT_IMG: `${cdnbasepath}/client/assets/images/icon/defaultSkuImage.png`,
    ONLINE_STORE_MODAL_IMG: `${cdnbasepath}/client/assets/images/icon/defaultSkuImage.png`,
    ONLINE_STORE_BUY_PRD_IMG: `${cdnbasepath}/client/assets/images/icon/defaultSkuImage.png`,
    ONLINE_STORE_PAY_IMG: `${cdnbasepath}/client/assets/images/icon/defaultSkuImage.png`,
    ONLINE_STORE_DISCOUNT_IMG: `${cdnbasepath}/client/assets/images/icon/defaultSkuImage.png`,
    NOREWARD_IMG: `${cdnbasepath}/client/assets/images/sad_smiley.png`,
    MOBILESIDENAV_REWARDS: `${cdnbasepath}/client/assets/images/icon/defaultSkuImage.png`
};

const OPTIONS = {
    PHYSICAL_STORE: {
        FIND_BY_DESC: "Go to any of the brand store. And purchase any products.",
        STORE_APPLY_DESC: "Show your rewards ID in the bill counter and apply the code.",
        DISCOUNT_DESC: "Get flat 4% discount on your total amount and get 4% discount from your final bill amount.",
        BTN_TEXT: "VISIT OUR NEARBY STORES"
    },
    ONLINE_STORE: {
        BUY_PRD_DESC: "Visit any of our Brand’s website and purchase a product.",
        PAY_DESC: "Enter the Rewards ID in the payment section and proceed the process.",
        DISCOUNT_DESC: "Get flat 4% discount on your total amount and get 4% discount from your final bill amount.",
        BTN_TEXT: "SHOP NOW"
    }
};

export { REWARD_LABELS, ENDPOINTS, OPTIONS, MYREWARDS_MESSAGES, TAB_NAMES }